// extracted by mini-css-extract-plugin
export default {"main":"Signup_main__ofLm7","email":"Signup_email__6cEXs"};